<template>
	<span>
		<v-menu
			v-model="menu"
			content-class="menu elevation-24"
			:close-on-content-click="false"
			fixed left nudge-right="8">
			<template v-slot:activator="{ on }">
				<v-btn
					flat icon
					title="Jobs suivis"
					class="mr-2"
					:disabled="Object.keys(jrs).length === 0"
					color="yellow accent-3"
					v-on="on">
					<v-icon
						v-if="Object.keys(jrs).length || pulsing"
						:class="{ pulse: pulsing }">
						star
					</v-icon>
					<v-icon v-else :class="{ pulse: pulsing }">
						star_outline
					</v-icon>
				</v-btn>
			</template>

			<v-card class="background darken-2">
				<v-card-title class="subheading py-1 pr-1">
					Mes jobs suivis
					<v-spacer></v-spacer>
					<v-btn flat icon small @click="menu = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-0 background darken-2 menu-content">
					<table width="100%">
						<tbody v-for="(jr, id) in jrs" :key="id" :jr="jr">
							<tr>
								<td>
									<v-btn
										flat icon
										color="warning"
										@click="removeJr(id)"
										class="ma-0">
										<v-icon>close</v-icon>
									</v-btn>
								</td>
								<td>
									<div class="jr-infos">{{ jr.label }}</div>
									<div class="caption jr-infos">
										{{ jr.storage.title || '-' }}
									</div>
									<div class="caption jr-infos">
										{{ jr.storage.label || '-' }}
									</div>
								</td>
								<td class="text-center">
									<div :class="$colors.setColorText(jr)">
										{{ jr.get_status_display }}
									</div>
									<v-progress-linear
										:value="jr.progress"
										height="20"
										:color="$colors.setColor(jr)[0]"
										class="my-1">
										{{ Math.floor(jr.progress) }} %
									</v-progress-linear>
								</td>
								<td>
									<v-btn
										flat icon
										:to="{name: 'Maestro job', params: {jr_id: jr.id}}"
										target="_blank"
										class="ma-0">
										<v-icon>open_in_new</v-icon>
									</v-btn>
								</td>
							</tr>
						</tbody>
					</table>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						flat
						class="text-none"
						color="warning"
						:disabled="Object.keys(jrs).length === 0"
						@click="removeDoneJrs()">
						<v-icon class="mr-2">delete_sweep</v-icon>
						Purger les jobs terminés
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-menu>
	</span>
</template>

<script>
// JOBS single
// JOBS multi
// LAUNCHER
import desktop_notifier from '@/services/desktop_notifier'
const LS_NAME = 'followed_jrs'

const getJrChanges = (jr_old, jr_new, that) => {
	let changes = []
	if (jr_old) {
		if (jr_old.status !== jr_new.status &&
				jr_new.status === that.$getConst('DONE')) {
			changes.push('Job Terminé')
		}
		let oldTasks = that.$commons.arrayToObject(jr_old.tasks, 'id')
		jr_new.tasks.map(newTask => {
			if (newTask.trigger === that.$getConst('MANUAL')) {
				if (oldTasks.hasOwnProperty(newTask.id)) {
					if (oldTasks[newTask.id].status !== newTask.status &&
							(newTask.status === that.$getConst('DONE') ||
							newTask.status === that.$getConst('WAITING'))) {
						changes.push(`Tâche ${newTask.label} ${newTask.status_text}`)
					}
				}
			}
		})
	} else {
		if (jr_new.status === that.$getConst('DONE')) {
			changes.push('Job Terminé')
		}
		jr_new.tasks.map(newTask => {
			if (newTask.trigger === that.$getConst('MANUAL')) {
				if (newTask.status === that.$getConst('DONE') ||
						newTask.status === that.$getConst('WAITING')) {
					changes.push(`Tâche ${newTask.label} ${newTask.status_text}`)
				}
			}
		})
	}
	if (changes.length) {
		return {
			title: `#${jr_new.id} ${jr_new.label}`,
			message: changes.join(' | '),
			url: `${window.appConfig._$92sql3}/maestro/job/${jr_new.id}`
		}
	}
	return null
}
export default {
	data () {
		return {
			menu: false,
			jrs: {},
			pulsing: false,
			max_count: 30
		}
	},
	watch: {
		menu (val) {
			if (val) {
				this.getJrsData(JSON.parse(window.localStorage.getItem(LS_NAME)) || [])
			}
		}
	},
	methods: {
		removeJr (id) {
			this.$delete(this.jrs, id)
			window.localStorage.setItem(
				LS_NAME,
				JSON.stringify(Object.keys(this.jrs))
			)
			if (Object.keys(this.jrs).length === 0) this.menu = false
		},
		removeDoneJrs () {
			let ids = []
			for (const id in this.jrs) {
				if (this.jrs[id].status !== this.$getConst('DONE')) ids.push(id)
			}
			window.localStorage.setItem(LS_NAME, JSON.stringify(ids))
			this.getJrsData(ids, true)
			if (ids.length === 0) this.menu = false
		},
		pulse () {
			this.pulsing = true
			setTimeout(() => {
				this.pulsing = false
			}, 2000)
		},
		getJrsData (jrIds, detectChanges) {
			if (jrIds.length === 0) {
				this.jrs = {}
				return
			}
			this.loading = true
			let hasChanged = false
			let filters = { page: 1, per_page: jrIds.length, job_ids: jrIds }
			this.$EsMaestro.jobrequest_list(filters)
				.then(results => {
					if (detectChanges) {
						for (const jr of results.jobs) {
							let change = getJrChanges(this.jrs[jr.id] || null, jr, this)
							if (change) {
								hasChanged = true
								desktop_notifier.notifier(
									change.title,
									change.message,
									change.url
								)
							}
							this.$set(this.jrs, jr.id, jr)
						}
					}
					this.jrs = this.$commons.arrayToObject(results.jobs, 'id')
				})
				.catch(error => {
					console.log(error)
				})
				.finally(() => {
					this.loading = false
					if (hasChanged > 0) {
						this.pulse()
					}
				})
		},
		autorefresh () {
			let activeJrIds = []
			let hasDeleted = false
			for (const id in this.jrs) {
				if (this.jrs[id].status !== this.$getConst('DONE')) {
					activeJrIds.push(id)
				} else if (this.jrs[id].status === this.$getConst('DONE')) {
					let endDate = new Date(this.jrs[id].end_date)
					let now = new Date()
					if (now.getTime() - endDate.getTime() > 24 * 60 * 60 * 1000) {
						hasDeleted = true
						this.$delete(this.jrs, id)
					}
				}
			}
			if (hasDeleted) {
				let ids = Object.keys(this.jrs)
				window.localStorage.setItem(LS_NAME, JSON.stringify(ids))
			}
			if (activeJrIds.length) {
				let hasChanged = false
				this.loading = true
				let filters = {
					page: 1,
					per_page: activeJrIds.length,
					job_ids: activeJrIds
				}
				this.$EsMaestro.jobrequest_list(filters)
					.then(results => {
						for (const jr of results.jobs) {
							let change = getJrChanges(this.jrs[jr.id] || null, jr, this)
							if (change) {
								hasChanged = true
								desktop_notifier.notifier(
									change.title,
									change.message,
									change.url
								)
							}
							this.$set(this.jrs, jr.id, jr)
						}
					})
					.catch(error => {
						console.log(error)
					})
					.finally(() => {
						this.loading = false
						if (hasChanged > 0) {
							this.pulse()
						}
						setTimeout(() => {
							this.autorefresh()
						}, 10000)
					})
			} else {
				setTimeout(() => {
					this.autorefresh()
				}, 10000)
			}
		}
	},
	mounted () {
		let lsJrs = JSON.parse(window.localStorage.getItem(LS_NAME)) || []
		this.getJrsData(lsJrs, false)
		this.autorefresh()
		this.$Bus.$on('follow-jrs', (jr_ids) => {
			this.pulse()
			let lsJrs = JSON.parse(window.localStorage.getItem(LS_NAME)) || []
			for (const id of jr_ids) {
				if (lsJrs.indexOf(id) === -1) lsJrs.push(id)
			}
			if (lsJrs.length > this.max_count) {
				this.$EventDialer(
					'error',
					false,
					`Suivi des jobs plein`,
					[
						`Il est possible de suivre au maximum ${this.max_count} jobs.`,
						'Veuiller faire de la place dans votre liste de suivi.'
					],
					0
				)
			} else {
				window.localStorage.setItem(LS_NAME, JSON.stringify(lsJrs))
				this.getJrsData(lsJrs, true)
			}
		})
	}
}
</script>

<style lang="stylus" scoped>
.menu
	top: 0 !important
	border-bottom-left-radius: 6px
	border-bottom-right-radius: 6px
	border-left: 1px solid var(--v-background-lighten1)
	border-right: 1px solid var(--v-background-lighten1)
	border-bottom: 1px solid var(--v-background-lighten1)

.menu-content
	max-height: calc(100vh - 48px - 52px)
	overflow: auto

table
	min-width: 300px
	max-width: 400px
	td
		padding: 2px 6px
		.jr-infos
			min-width: 150px
			max-width: 300px
			text-wrap: nowrap
			overflow: auto
		.v-progress-linear
			border-radius: 4px
	tr
		border-top: 1px solid var(--v-background-lighten1)
		&:last-child
			border-bottom: 1px solid var(--v-background-lighten1)
.pulse
	border-radius: 50%
	animation: pulse 0.5s infinite

@keyframes pulse
	0%
		transform: scale(0.95)
		box-shadow: 0 0 12px 2px rgba(255, 234, 0, 1)
	70%
		transform: scale(1.5)
		box-shadow: 0 0 32px 6px rgba(255, 234, 0, 0.5)
	100%
		transform: scale(0.95)
		box-shadow: 0 0 0 0 rgba(255, 234, 0, 0.2)
</style>



// WEBPACK FOOTER //
// src/components/globals/followed_jrs.vue